import React from 'react';
import {
  Row, Col, ModalHeader, Modal, ModalBody, ModalFooter, Button
} from 'reactstrap';
import Loading from './Loading';

const DeleteConfirmation = ({
  isOpen, toggle, type, delete: Delete, loading, message
}) => (
  <Modal
    isOpen={isOpen}
    toggle={toggle}
    className='modal-primary modal-dialog-centered'
  >
    <div>
      <ModalHeader toggle={toggle}>Confirm removal</ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            {`${message || ''}Do you really want to remove the ${type}?`}
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        {loading ? (
          <Loading loading withoutStyles />
        ) : (
          <>
            <Button id='btn-cancel' type='reset' color='danger' onClick={toggle}>
              <i className='fa fa-ban' />
              {' Cancel'}
            </Button>
              &nbsp;
            <Button id='btn-confirm' type='submit' color='primary' onClick={Delete}>
              <i className='fa fa-dot-circle-o' />
              {' Delete'}
            </Button>
          </>
        )}
      </ModalFooter>
    </div>
  </Modal>
);

export default DeleteConfirmation;
